import {Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl} from '@angular/forms';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';
import {FloatLabelType, MatFormFieldAppearance} from '@angular/material/form-field';
import dayjs from 'dayjs';
import 'dayjs/locale/uk';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(localizedFormat);
dayjs.locale('uk');

export const MY_FORMATS = {
    parse: { dateInput: 'MM/yyyy' },
    display: {
        dateInput: 'MMM yyyy',
        monthYearLabel: 'MMM yyyy',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM yyyy',
    },
};

@Component({
    selector: 'app-months-datepicker',
    templateUrl: './months-datepicker.component.html',
    styleUrls: ['./months-datepicker.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: NativeDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MonthsDatepickerComponent), multi: true },
    ],
    standalone: false,
})
export class MonthsDatepickerComponent implements ControlValueAccessor, OnInit, OnChanges {
    hiddenControl: UntypedFormControl;
    displayValue = '';

    @Input() appearance: MatFormFieldAppearance = 'fill';
    @Input() floatLabel: FloatLabelType = 'always';
    @Input() fieldClass = 'no-padding full-width';
    @Input() panelClass = 'disabled-mat-calendar-period-button';
    @Input() label = '';
    @Input() disabled = false;
    @Input() minDate: Date | null = null;
    @Input() maxDate: Date | null = null;

    private _value: Date | null = null;

    get value(): Date | null {
        return this._value;
    }

    @Input()
    set value(val: Date | null) {
        this._value = val;
        this.displayValue = val ? dayjs(val).format('MMM YYYY') : '';

        // this.onChange(this._value);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange(_: any) {}

    ngOnInit(): void {
        this.hiddenControl = new UntypedFormControl({ value: '', disabled: this.disabled });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes['disabled'] && this.hiddenControl) {
            this.disabled ? this.hiddenControl.disable() : this.hiddenControl.enable();
        }
    }

    chosenYearHandler(normalizedYear: Date) {
        const ctrlValue = this.hiddenControl.value instanceof Date ? new Date(this.hiddenControl.value) : new Date();
        ctrlValue.setFullYear(normalizedYear.getFullYear());
        this.setValue(ctrlValue);
    }

    chosenMonthHandler(normalizedMonth: Date, datepicker: MatDatepicker<Date>) {
        const ctrlValue = new Date(
            normalizedMonth.getFullYear(),
            normalizedMonth.getMonth(),
            1,
            0, 0, 0, 0
        );

        this.setValue(ctrlValue);
        datepicker.close();
    }

    private setValue(date: Date) {
        this.hiddenControl.setValue(date);
        this.value = date;

        this.onChange(date);
    }

    writeValue(value: Date | null) {
        this.hiddenControl.setValue(value);
        this.value = value;
    }

    registerOnChange(fn: any) { this.onChange = fn; }
    registerOnTouched() {}
}
